<template>
  <notifications position="top center" width="350" />
  <router-view />
  <a href="" style="display: none" class="invisible-link"></a>
</template>
